import type { FilterType } from "../types";
import { filterToSql, type RelativeWindowOptions } from "./filter-to-sql";

export const filtersToWhereClause = (
  filters: FilterType[],
  opts?: RelativeWindowOptions,
): string => {
  const first = filters[0];
  if (!first) return "";

  let expr = filterToSql(first, opts);

  for (let i = 1; i < filters.length; i++) {
    const filter = filters[i];
    if (!filter) continue;
    const pred = filterToSql(filter, opts);
    if (filter.logicOperator === "OR") {
      expr = `(${expr} OR ${pred})`;
    } else {
      expr = `(${expr} AND ${pred})`;
    }
  }

  return expr;
};
